/** Idade completa em anos na data de hoje (ambas YYYY-MM-DD, calendário de São Paulo). */
export function ageOn(birthDate: string, today: string): number {
  const [by, bm, bd] = birthDate.split("-").map(Number) as [number, number, number];
  const [ty, tm, td] = today.split("-").map(Number) as [number, number, number];
  let age = ty - by;
  if (tm < bm || (tm === bm && td < bd)) age -= 1;
  return age;
}

export function isMinor(birthDate: string, today: string): boolean {
  return ageOn(birthDate, today) < 18;
}

/** A matrícula aceita alunos entre 6 e 100 anos. */
export function isAllowedStudentAge(birthDate: string, today: string): boolean {
  const age = ageOn(birthDate, today);
  return age >= 6 && age <= 100;
}
